import React, { useEffect, useState } from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import * as images from "../../constants/Images";
import BookmarksService from "../../services/BookmarksService";
import { format } from "date-fns";
import PropTypes from "prop-types";
import "./AsideCards.css";
import MDTUsers from "./MDTusers";
import { useSelector } from "react-redux";
import { ShowAttachment } from "../DataCards2/DataCards2";
import { getFromEncLocalStorage, storeInEncLocalStorage } from "../../helpers/Utils/Utils";
import { encryptV2 } from "../../helpers/Cryptography/CryptoV2";
import { Redirect } from "react-router";

const AsideCardsNew = (props) => {
  const [bookmarks, setBookmarks] = useState([]);
  const [val, setVal] = useState(props.update);
  const [details, showDetail] = useState(false);
  const [detailId, setDetail] = useState("");
  const [isKnowledge, setKnowledge] = useState(false);

  const shouldUpdateBookmarks = useSelector((state) => state.updateBookmark);
  // mdtUsersdata : []

  const knowledgeDetailsData = localStorage.getItem("knowledgeDetailsData")
  ? JSON.parse(getFromEncLocalStorage("knowledgeDetailsData"))
  : props.location;

  useEffect(() => {
    getBookmarks();
  }, [shouldUpdateBookmarks]);

  const getBookmarks = async () => {
    let reqBody = {
      limit: 3,
      pageNo: 1,
    };
    const res = await BookmarksService.getBookmarks(reqBody);

    if (res) {
      setBookmarks(res);
    }
  };

  const setDetails = (id, isKnowledge) => {
    localStorage.setItem("position", window.pageYOffset);
    setDetail(id);
    showDetail(true);
    setKnowledge(isKnowledge);
  };


  if (details) {
    let path = props?.location ? props.location : "/home";
    // let path = 'Home';
    if (
      path == "/details" &&
      knowledgeDetailsData &&
      knowledgeDetailsData.from
    ) {
      path = knowledgeDetailsData.from;
    }
    const detailsData = {
      id: detailId,
      isKnowledge: isKnowledge,
      from: path,
      redirected: true,
    };

    storeInEncLocalStorage("knowledgeDetailsData", JSON.stringify(detailsData))

    if (path != "/details" && props?.location != "/details") {
      return (
        <Redirect
          to={{
            pathname: "/details",
            state: detailsData,
          }}
        />
      );
    } else {
      window.location.reload();
    }
  }

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="display-row justify-space-between">
            <h6 className="card-title">Bookmarks</h6>
            <img src={images.bookmark_black} className="aside-card-icon" />
          </div>
          <hr style={{ margin: "5px 0 10px 0" }} />

          {bookmarks.length > 0 ? (
            bookmarks.map((bookmark) => (
              <div
                className="card mb-3"
                style={{ margin: 0 }}
                key={bookmark.id}
              >
                <div className="row g-0">
                  <div className="col-md-3">
                    {/* <img
                      src={images.login_background}
                      className=" card-img aside-card-img"
                    /> */}
                    {(bookmark.attachment_file_type !== null &&
                      bookmark.attachment !== null) ||
                    (bookmark.video_id != null && bookmark.video_id != "") ? (
                      <ShowAttachment
                        aType={bookmark.attachment_file_type}
                        attachment={bookmark.attachment}
                        videoId={bookmark.video_id}
                        thumbnailId={bookmark.thumbnailId}
                        thumbnail={bookmark.thumbnail}
                        isFromAsideCards={true}
                        videoMetadata={bookmark?.VideoMetadata}
                      />
                    ) : null}
                  </div>
                  <div
                    className="col-md-9"
                    onClick={() => {
                      setDetails(bookmark.id, bookmark.isKnowledge);
                    }}
                    style={{ cursor: "pointer" }}
                    title="View details"
                  >
                    <div className="card-body aside-card-body bookmarrk-card">
                      <h6 style={{ fontSize: "0.80rem" }}>
                        {bookmark.title.length > 30
                          ? bookmark.title.substring(0, 30) + "..."
                          : bookmark.title}
                      </h6>
                      <p style={{ fontSize: "0.70rem" }}>
                        {bookmark.description.length > 80
                          ? bookmark.description.substring(0, 80) + "..."
                          : bookmark.description}
                      </p>
                      <p className="small-card-text">
                        <span>
                          {format(
                            new Date(bookmark.created_date),
                            "MMMM dd yyyy"
                          )}
                        </span>
                        <span
                          style={{ fontWeight: "bold", marginLeft: "15px" }}
                        >
                          {bookmark.creator}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="card">
              <div className="card-body">
                <p>No bookmarks</p>
              </div>
            </div>
          )}

          <Link to="/bookmarks" className="justify-space-around">
            <h6 className="view-all-button">View all</h6>
          </Link>
        </div>
      </div>

      {/* <div className="card">
          <div className="card-body">
            <div className="display-row justify-space-between">
              <h6 className="card-title">Trending Experts</h6>
              <img src={images.ask_expert} className="aside-card-icon" />
            </div>
            <hr style={{ margin: "5px 0 5px 0" }} />
            <div className="card mb-3" style={{ margin: 0 }}>
              <div className="row g-0">
                <div className="col-md-3">
                  <img
                    src={images.login_background}
                    className=" card-img aside-card-img"
                  />
                </div>
                <div className="col-md-9">
                  <div className="card-body">
                    <h6 style={{ display: "inline", fontSize: "0.80rem" }}>
                      Manoj Garai
                    </h6>
                    <span style={{ fontSize: "0.80rem" }}>(34 Posts)</span>
                    <p style={{ fontSize: "0.7rem" }}>Manager, M&M IT</p>
                  </div>
                </div>
              </div>
            </div>
            <Link to="/bookmarks" className="justify-space-around">
              <h6 className="view-all-button">View all</h6>
            </Link>
          </div>
        </div> */}

      <div className="card">
        <div
          className="card-body"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <MDTUsers />
        </div>
      </div>
    </div>
  );
};

export default AsideCardsNew;

AsideCardsNew.propTypes = {
  update: PropTypes.bool,
};
